import { all, fork } from 'redux-saga/effects';
import { watchUserSaga } from 'redux/sagas/watchUser';
import { watchAssetSaga } from 'redux/sagas/watchAsset';
import { watchStorageSaga } from 'redux/sagas/watchStorage';
import { watchCategorySaga } from 'redux/sagas/watchCategory';
import { watchWkblScriptSaga } from 'redux/sagas/watchWkblScript';
import { watchScriptSaga } from 'redux/sagas/watchScript';
import { watchLibrarySaga } from 'redux/sagas/watchLibrary';
import { watchWkblVideoSaga } from 'redux/sagas/watchWkblVideo';
import { watchWkblSpecialVideoSaga } from 'redux/sagas/watchWkblSpecialVideo';
import { watchCodeSaga } from 'redux/sagas/watchCode';
import { watchPreferenceSaga } from 'redux/sagas/watchPreference';
import { watchConfigSaga } from 'redux/sagas/watchConfig';
import { watchLibraryNotificationSaga } from 'redux/sagas/watchLibraryNotification';
import { watchStatisticsSaga } from './watchStatistics';
import { watchStatisticsLogSaga } from './watchStatisticsLog';
import { watchAwsSaga } from './watchAws';
export default function* rootSaga() {
  yield all([
    watchUserSaga(),
    watchAssetSaga(),
    watchStorageSaga(),
    watchCategorySaga(),
    watchWkblScriptSaga(),
    watchLibrarySaga(),
    watchScriptSaga(),
    watchWkblVideoSaga(),
    watchWkblSpecialVideoSaga(),
    watchCodeSaga(),
    watchPreferenceSaga(),
    watchConfigSaga(),
    watchLibraryNotificationSaga(),
    watchStatisticsSaga(),
    watchStatisticsLogSaga(),
    watchAwsSaga()
  ]);
}
